require('../singleGameService');

angular.module('app.shared.graphicOverlay.graphicOverlayController', [
  'app.shared.singleGameService'
])
  .controller('app.shared.graphicOverlay.graphicOverlayController', [
    '$scope',
    'app.shared.singleGameService',
    function ($scope, singleGame) {
      "use strict";
        
      $scope.game = $scope.game || null;
      $scope.layout = $scope.layout || null;
      $scope.save = $scope.save || null;

      let init = function () {
        $scope.game = singleGame.transform($scope.game);
      };

      $scope.splitText = function () {
        if ($scope.game && $scope.game.overlay) {
          $scope.game.overlay.splitText = singleGame.splitOverlayText($scope.game.overlay.stroverlayoverride);
        }
      };

      $scope.mergeText = function () {
        if ($scope.game && $scope.game.overlay) {
          $scope.game.overlay.stroverlayoverride = $scope.game.overlay.splitText.join(';');
        }
      };

      $scope.$watch(
        function () {
          if ($scope.game) {
            return $scope.game.igameid;
          }
          return null;
        },
        function () {
          init();
        }
      );

      init();
    }
  ]);



// WEBPACK FOOTER //
// ./app.v2/components/shared/graphicOverlay/graphicOverlayController.js